// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Jvs","delete":"styles_delete__2ys7K","update":"styles_update__2e9_Z","add":"styles_add__85xyt"};